import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { LoginComponent } from './login.component';
import { ContactITDialogComponent } from './contact-it-dialog';
import { authModuleConfig } from '../auth.config';

const routes = [
  {
    path: authModuleConfig.loginPageRoute,
    component: LoginComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),

    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,

    TranslateModule,
    FuseSharedModule,
  ],
  declarations: [LoginComponent, ContactITDialogComponent],
  exports: [ContactITDialogComponent],
})
export class LoginModule {}
